import { apiInstance } from '@crm/shared/api'
import { keysToCamel } from '@crm/shared/lib'

import { projectApiRoutes } from './api-routes'

import type { TCreateProjectParams } from '../model'
import type { TDealDetailsDto } from '@crm/entities/deal'
import type { TBaseResponseType } from '@crm/shared/model/BaseResponse.type'

export const projectApi = {
  createProject: async ({ dealId }: TCreateProjectParams) => {
    const response = await apiInstance
      .post(projectApiRoutes.createProject(dealId))
      .json<TBaseResponseType<TDealDetailsDto>>()

    return keysToCamel(response.data)
  },
}
